import { YMD } from '@/utils/date'
import { defineStore } from 'pinia'

export default defineStore('app', {
	state: () => ({
		isLoading: false,
		sidebar: false,
		fullscreen: false,
		date: new Date()
	}),

	getters: {
		formattedDate: (state) => state.date.toLocaleDateString('en-GB'),
		queryDate: (state) => YMD(state.date)
	},

	actions: {
		loading(value: boolean) {
			this.isLoading = value
		},

		toggleFullscreen() {
			this.fullscreen = !this.fullscreen
		},

		toggleSidebar(scroll = true) {
			this.sidebar = !this.sidebar

			if (scroll === false) {
				const body = document.body
				body.classList.toggle('overflow-hidden', this.sidebar)
			}
		},

		nextDay() {
			this.date = new Date(this.date.setDate(this.date.getDate() + 1))
		},

		prevDay() {
			if (!this.isToday()) {
				this.date = new Date(this.date.setDate(this.date.getDate() - 1))
			}
		},

		today() {
			this.date = new Date()
		},

		isToday() {
			const today = new Date()
			return this.date.setHours(0, 0, 0, 0) == today.setHours(0, 0, 0, 0)
		}
	}
})
